import $http from '@/plugins/axios'
import AppService from '@/services/app.service'

const StatisticService = {
    searchUser (search, pagination) {
        let str = 'search=' + search
        str += '&' + AppService.mapPagination(pagination)
        return $http.get('/statistic/users/?' + str)
    },
    getUserStatistic (userId, timeRangeList) {
        return $http.get('/statistic/users/' + userId + '/statistic/?time_series=' + timeRangeList.join(','))
    },
    searchProject (search, pagination) {
        let str = 'search=' + search
        str += '&' + AppService.mapPagination(pagination)
        return $http.get('/statistic/projects/?' + str)
    },
    getProjectStatistic (projectId, timeRangeList) {
        return $http.get('/statistic/projects/' + projectId + '/statistic/?time_series=' + timeRangeList.join(','))
    },
    getUserGeneralStatistic (timeRangeList) {
        return $http.get('/statistic/user-statistic/?time_series=' + timeRangeList.join(','))
    },
    getActiveApiStatistic (timeRangeList) {
        return $http.get('/statistic/active-api/?time_series=' + timeRangeList.join(','))
    },
    getActiveUserStatistic (start, end, max = 5) {
        return $http.get(`/statistic/active-user/?start=${start}&end=${end}&max=${max}`)
    },
    getActiveProjectStatistic (start, end, max = 5) {
        return $http.get(`/statistic/active-project/?start=${start}&end=${end}&max=${max}`)
    }
}

export default StatisticService
